module.exports = __webpack_public_path__ + "img/restart.495f6621.svg";